<template>
    <div id="homeBox">
        <!--头部-->
        <div class="flex mrl20 mrt20">
            <template>
                <span class="mrt10">选择日期:</span>
                <el-date-picker
                        v-model="begin_time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
                <span class="mrt10">至</span>
                <el-date-picker
                        v-model="end_time"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
            </template>
            <el-input class="mrl20" style="width: 10%" v-model="vcName" placeholder="请输入品名" clearable></el-input>
            <el-button class="mrl20" icon="el-icon-search" circle  @click="searchData"></el-button>
            <el-button class="mrl20" type="primary" @click="addData" :class="baseerp+'btn'">添加</el-button>
            <el-button type="primary" @click="editData" :disabled="disabled" :class="baseerp+'btn'">编辑</el-button>
        </div>
        <!--表单部分-->
        <div style="width:100%;height:80%">
            <el-table
                    :height="tableHeight"
                    :data="tableData"
                    style="width: 100%"
                    class="mrt20"

                    :header-cell-style="{background:'#eef1f6',color:'#000'}"
                    @row-click="rowClick"
                    :highlight-current-row="highlightCurrentRow">
                <el-table-column
                        prop="i_id"
                        label="申请单号"
                        width="140">
                </el-table-column>
                <el-table-column
                        prop="vc_gsname"
                        :label="$t('form_company')"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_ckname"
                        :label="$t('form_warehouse')"
                        width="140">
                </el-table-column>
                <el-table-column
                        prop="vc_pzname"
                        :label="$t('form_product_name')"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="vc_no"
                        label="库号"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="f_num"
                        label="申请数量"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="f_outnum"
                        label="已出库"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="vc_unit"
                        label="单位"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="vc_squname"
                        label="申请人"
                        width="90"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="dt_createtime"
                        label="申请日期"
                        show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                        prop="state"
                        label="状态"
                        width="80">
                </el-table-column>
            </el-table>
        </div>
        <!--dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                     width="1000px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <application-form :application="application" @close="cancelDialog" @getPickingReqList="getPickingReqList"></application-form>
            </el-dialog>
        </div>

        <!--分页-->
        <div>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="pageCurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import * as API from  "./api";
    import axios from "axios";
    import ApplicationForm from "./ApplicationForm";
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "requisitionApplication",

        components:{ApplicationForm},

        mounted(){
            this.baseerp=baseerp;
            ///调用列表接口
            //this.getlist();
            this.$nextTick(()=>{
                this.onResize()
            })
            this.getPickingReqList();
        },

        data(){
            return{
                tableHeight:0,
                dialogVisible:false,
                title:"",
                begin_time:"",
                end_time:"",
                tableData:[],
                pageSize:100,
                currentPage:1,
                tableTotal:0,
                vcName:"",
                application:{},
                highlightCurrentRow:false,
                disabled:false,
                baseerp:"",
                mid:0,
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        methods:{
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-120

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),

            //拿到当前行数据
            rowClick(row){
                this.highlightCurrentRow=true;
                //console.log(row,"row");
                this.application.i_pid=row.i_pid;
                //console.log(this.application,"this.application")
            },

            //关闭dialog
            cancelDialog(val){
                //console.log(val,"val,,,,,,");
                this.application.i_pid="";
                this.dialogVisible=false;
                //console.log(this.application.i_pid,"cancelDialog");
                this.highlightCurrentRow=false;
                this.getPickingReqList(val);
            },

            //点击编辑
            editData(){
                this.title="编辑领料单";
                if (this.application.i_pid==""||this.application.i_pid==undefined){
                    this.dialogVisible=false;
                    this.$message.error("请选择要编辑的行内容！")
                }else{
                    this.application={
                        i_pid:this.application.i_pid,
                        page_size:this.currentPage,
                        i_mid:this.mid,
                    };
                    //console.log(this.application,"editData");
                    this.dialogVisible=true;
                }

            },

            //点击添加
            addData(){
                this.title="添加领料单";
                this.highlightCurrentRow=false;
                this.application={
                    i_pid:0,
                    page_size:1,
                    i_mid:this.mid,
                };
                //console.log(this.application,"addData");
                this.dialogVisible=true;
            },




            //点击查询
            searchData(){
               // console.log(this.vcName,this.begin_time,this.end_time,"searchData")
                ///调用列表接口
                this.getPickingReqList();
            },

            //列表接口
            // getlist(){
            //     const that=this;
            //     axios.get("./requestlist.json").then(function (res) {
            //         console.log(res.data,"getlist");
            //         that.tableData=res.data;
            //     })
            // },
            async getPickingReqList(pageSize){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                if(pageSize!=undefined) {
                    //console.log(pageSize,"addddd")
                    this.currentPage=pageSize;
                }
                let param = {
                    i_uid:"",
                    app:"",
                    token:"",
                    version:"",
                    i_mid: this.mid,
                    page_size:this.currentPage,
                    page_count:100,
                    begin_time:this.begin_time,
                    end_time:this.end_time,
                    vc_name:this.vcName,
                };
                let res = await API.getPickingReqList(param);
                if (res.code == 1) {
                    this.tableData=res.data;
                    this.tableTotal=res.count;
                    //console.log(this.tableData,this.tableTotal,"this.tableData");
                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            pageCurrentChange(val){
               // console.log(val,"pageval");
                this.currentPage=val;
                ///调用列表接口
                this.getPickingReqList();
            },
        },
    }

</script>

<style lang="scss" scoped>
    .flex{
        justify-content: left;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .cl{
        clear: both;
    }
    .mrt10{
        margin-top: 10px;
    }
    .mrt20{
        margin-top: 20px;
    }
    .mrl20{
        margin-left: 20px;
    }
    .mrb40{
        margin-bottom: 60px;
    }
    .page{
        padding: 25px 15px;
    }
    /deep/{

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
    }

</style>